import { Analysis, AnalysisType, SubGroup } from 'projects/dop-ordering/src/public-api';
import { AnalysisDisplay } from 'src/app/shared/models/analysis-display.model';
import { AnalysesResponse, InvoiceableItemType } from '../models/specification/analyses-response.model';
import { StandardComment } from '../models/standard-comment.model';

export default class AnalysesDetailService {

    static setupDisplayAnalysis(
        analysisArray: Analysis[], currentOrderSubGroups: SubGroup[],enableMultipleDetermination: boolean,
        standardComments?: StandardComment[]): AnalysisDisplay[] {
        const analysisDisplayArray: AnalysisDisplay[] = [];
        analysisArray?.forEach(analysis => {
            if (analysis.analysisType === AnalysisType.FreeQLPackage
                || analysis.analysisType === AnalysisType.FreeQLTest
                || analysis.analysisType === AnalysisType.CustomerPackage) {
                const analysisDisplay: AnalysisDisplay = {
                    sequence: analysis.sequence,
                    eurodatKey: analysis.eurodatKey,
                    code: analysis.testCode ? analysis.testCode : analysis.packageCode,
                    price: analysis.price,
                    displayName: analysis.displayName,
                    isParent: false,
                    childDisplay: [],
                    analysisType: analysis.analysisType,
                    sortIndex: analysis.sortIndex,
                    structuredComment: analysis.structuredComment !== undefined ?
                        standardComments?.filter(x => x.value === analysis.structuredComment)[0] : null,
                    isSubGroup: false,
                    executionNumber : enableMultipleDetermination ? analysis.executionNumber :1,
                    showSurgeIcon : analysis.showSurgeIcon ?? false,
                };
                analysisDisplayArray.push(analysisDisplay);
            } else if (analysis.analysisType === AnalysisType.MonographTest
                || analysis.analysisType === AnalysisType.MonographPackage) {
                const analysisDisplay: AnalysisDisplay = {
                    sequence: analysis.sequence,
                    code: analysis.analysisType === AnalysisType.MonographTest ? analysis.testCode : analysis.packageCode,
                    price: analysis.price,
                    displayName: analysis.displayName,
                    isParent: false,
                    childDisplay: [],
                    analysisType: analysis.analysisType,
                    sortIndex: analysis?.sortIndex,
                    monographCode: analysis.monographCode,
                    monographName: analysis.monographName,
                    compendiumCode: analysis.compendiumCode,
                    compendiumName: analysis.compendiumName,
                    salesCatalogueCode: analysis.salesCatalogCode,
                    structuredComment: analysis.structuredComment !== undefined ?
                    standardComments?.filter(x => x.value === analysis.structuredComment)[0] : null,
                    executionNumber : enableMultipleDetermination ? analysis.executionNumber :1,
                    showSurgeIcon : analysis.showSurgeIcon ?? false,

                };
                analysisDisplayArray.push(analysisDisplay);
            } else if (analysis.analysisType === AnalysisType.SalesCatalogueTest
                || analysis.analysisType === AnalysisType.SalesCataloguePackage
                || analysis.analysisType === AnalysisType.SalesCatalogueTestBundle) {
                const analysisDisplay: AnalysisDisplay = {
                    sequence: analysis.sequence,
                    code: (analysis.analysisType === AnalysisType.SalesCatalogueTest
                        || analysis.analysisType === AnalysisType.SalesCatalogueTestBundle)
                        ? analysis.testCode : analysis.packageCode,
                    price: analysis.price,
                    displayName: analysis.displayName,
                    isParent: false,
                    childDisplay: [],
                    analysisType: analysis.analysisType,
                    sortIndex: analysis?.sortIndex,
                    salesCatalogueCode: analysis.salesCatalogCode,
                    subgroupCode: analysis.testBundleCode,
                    preparationTests: analysis.preparationTestCodes,
                    structuredComment: analysis.structuredComment !== undefined ?
                        standardComments?.filter(x => x.value === analysis.structuredComment)[0] : null,
                    executionNumber : enableMultipleDetermination ? analysis.executionNumber :1,
                    showSurgeIcon : analysis.showSurgeIcon ?? false,
                    };
                if (analysis.testBundleCode) {
                    const parent = analysisDisplayArray.find(x => x.isParent === true && x.subgroupCode === analysis.testBundleCode);
                    if (!parent) {
                        const parentDisplay: AnalysisDisplay = {
                            sequence: analysis.sequence,
                            isParent: true,
                            subgroupCode: analysis.testBundleCode,
                            displayName: analysis.testBundleDisplayName,
                            childDisplay: [],
                            code: analysis.testBundleCode,
                            price: 0,
                            analysisType: AnalysisType.SalesCatalogueTestBundle,
                            salesCatalogueCode: analysis.salesCatalogCode,
                            isSubGroup: true,
                            executionNumber : enableMultipleDetermination ? analysis.executionNumber :1,
                            showSurgeIcon : analysis.showSurgeIcon ?? false,
                        };
                        parentDisplay.childDisplay.push(analysisDisplay);
                        analysisDisplayArray.push(parentDisplay);
                    } else {
                        parent.childDisplay.push(analysisDisplay);
                    }
                } else {
                    analysisDisplayArray.push(analysisDisplay);
                }
            } else {
                const SG = currentOrderSubGroups?.filter(x => x.code === analysis.subGroupKey).shift();

                const parent = analysisDisplayArray.filter(x => x.isParent === true
                    && x.subgroupCode === analysis.subgroupCode
                    && x.displayName === SG?.name).shift();

                const childDisplay: AnalysisDisplay = {
                    sequence: analysis.sequence,
                    eurodatKey: analysis.eurodatKey,
                    code: analysis.testCode ? analysis.testCode : analysis.packageCode,
                    price: analysis.price,
                    displayName: analysis.displayName,
                    isParent: false,
                    childDisplay: [],
                    analysisType: analysis.analysisType,
                    sortIndex: analysis.sortIndex,
                    structuredComment: analysis.structuredComment !== undefined ?
                        standardComments?.filter(x => x.value === analysis.structuredComment)[0] : null,
                    isSubGroup: true,
                    executionNumber : enableMultipleDetermination ? analysis.executionNumber :1,
                    showSurgeIcon : analysis.showSurgeIcon ?? false,
                };

                if (parent) {
                    parent.childDisplay.push(childDisplay);
                } else {
                    const analysisDisplay: AnalysisDisplay = {
                        sequence: analysis.sequence,
                        eurodatKey: analysis.subGroupKey,
                        code: '',
                        price: analysis.price,
                        displayName: SG?.name,
                        isParent: true,
                        childDisplay: [],
                        subgroupCode: SG?.comlimsCode,
                        analysisType: AnalysisType.FullSubgroup,
                        sortIndex: analysis.sortIndex,
                        structuredComment: analysis.structuredComment !== undefined ?
                            standardComments?.filter(x => x.value === analysis.structuredComment)[0] : null,
                        isSubGroup: true,
                        executionNumber : enableMultipleDetermination ? analysis.executionNumber :1,
                        showSurgeIcon : analysis.showSurgeIcon ?? false,
                    };
                    analysisDisplay.childDisplay.push(childDisplay);
                    analysisDisplayArray.push(analysisDisplay);
                }
            }
        });
        return analysisDisplayArray;
    }
}
